<nav class="nav navbar-expand-md navbar-light">

  <span class="navbar-brand"><app-logo></app-logo></span>

  <button class="navbar-toggler ml-auto collapsed" type="button" data-toggle="collapse"
          (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" data-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="fa fa-bars"></span>
  </button>
  <div class="navbar-collapse justify-content-end mt-5 mt-md-0" [collapse]="isCollapsed">
    <div class="navbar-nav">
      <div *ngIf="isSuperUser" class="nav-item nav-link d-flex justify-content-center">
        <ng-select [items]="onBehalfUsers"
                   [(ngModel)]="selectedUser"
                   placeholder="{{'labelOnBehalfOf' | translate}}"
                   [clearable]="false"
                   bindLabel="username"
                   (ngModelChange)="changeBehalfUser()"
                   bindValue="id"
                   [hideSelected]="true"
                   name="selectOnBehalfUser">
          <ng-template ng-option-tmp let-item="item">
            <span id="{{item.username}}">{{ item.username }}</span>
          </ng-template>
        </ng-select>
      </div>

      <a class="nav-item nav-link" (click)="openSettings()">Security Settings</a>
      <a class="nav-item nav-link" (click)="openEditStaticInfo()">Static data</a>
      <a class="nav-item nav-link" href="{{ 'HelpLink' | translate }}" target="_blank"><span [innerHTML]="'navHelp' | translate"></span></a>
      <a class="nav-item nav-link" (click)="logout()" id="logout"><span [innerHTML]="'navLogout' | translate"></span></a>
    </div>
  </div>
</nav>


<ng-template #settingsTemplate>

  <div class="modal-header bg-success d-flex align-items-center">
    <h4 class="modal-title text-muted" translate>labelHeader.changePassword</h4>
    <button type="button" tabindex="-1" class="close pull-right" aria-label="Close"
            (click)="modalRef.hide()">
      <i class="fa fa-times"  aria-hidden="true"></i>
    </button>
  </div>
  <div class="modal-body">

<!--        <div class="form-group mt-1">-->
<!--          <label class="text-white pt-1 mr-2">{{ 'labelLanguage' | translate}}: </label>-->
<!--          <span *ngIf="!oneLang" class="text-white">{{ selectedLang.name }}</span>-->
<!--        </div>-->

        <form class="mt-5" name="settingForm">
<!--          <div class="form-group">-->
<!--            <div class="input-group input-group-sm">-->
<!--              <span class="mr-4" translate>labelHeader.language</span>-->
<!--              <div class="btn-group" dropdown [isDisabled]="true">-->
<!--                <button dropdownToggle [disabled]="true" type="button" class="btn btn-sm btn-secondary dropdown-toggle" #language>-->
<!--                  {{ selectedLang.name }}</button>-->
<!--                <ul *dropdownMenu class="dropdown-menu" role="menu">-->
<!--                  <li class="dropdown-item"-->
<!--                      *ngFor="let language of languages"-->
<!--                      (click)="switchLanguage(language.abbrev);"-->
<!--                      value="{{language.name }}">{{ language.name }}</li>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </form>
    <ng-container *ngTemplateOutlet="passwordForm"></ng-container>

  </div>

  <div class="settings-footer mt-5">
    <h6 translate>buttonContact</h6>
    <p [innerHTML]="'contactModule.textInfo.text' | translate"></p>
  </div>
</ng-template>

<ng-template #passwordForm autocomplete="off">
  <form [formGroup]="passform" autocomplete="off" data-lpignore="true"  class="settings-form">

      <input type="password"
             (focus)="notFocused=false"
             (focusout)="notFocused=true"
             class="form-control mb-3"
             formControlName="oldPassword"
             autocomplete="off"
             readonly
             onfocus="this.removeAttribute('readonly')"
             placeholder="{{'labelOldPassword' | translate}}"
             required>

      <div class="mb-3">
        <input type="password"
               tooltip="{{'password.rules' | translate}}"
               [delay]="500"
               (focus)="notFocused=false"
               (focusout)="notFocused=true"
               class="form-control"
               formControlName="newPassword"
               autocomplete="off"
               readonly
               onfocus="this.removeAttribute('readonly')"
               placeholder="{{'labelNewPassword' | translate}}"
               required>
<!--        <span class="password-tooltiptext"-->
<!--              [innerHTML]="'password.rules' | translate"></span>-->
      </div>
      <div class="mb-3">
        <input type="password"
               (focus)="notFocused=false"
               (focusout)="notFocused=true"
               class="form-control"
               formControlName="newPasswordconf"
               autocomplete="off"
               readonly
               onfocus="this.removeAttribute('readonly')"
               placeholder="{{'labelConfirmNewPassword' | translate}}">
<!--        <span class="password-tooltiptext"-->
<!--              [innerHTML]="'password.rules' | translate"></span>-->
      </div>


<!--    <alert role="alert" dismissOnTimeout="4000" (onClosed)="isOpen=false"-->
<!--           *ngIf="isOpen && passChangeMessage ||-->
<!--      (passform.controls.oldPassword.errors?.required &&-->
<!--      passform.controls.oldPassword.touched && passform.controls.newPassword.errors?.required && passform.controls.newPassword.touched && passform.controls.newPasswordconf.errors?.required && passform.controls.newPasswordconf.touched) ||-->
<!--      (passform.errors?.doesMatchPassword && passform.controls.newPassword.touched && passform.controls.newPasswordconf.touched)">-->

<!--      <div-->
<!--        *ngIf="passform.controls.oldPassword.errors?.required &&-->
<!--        passform.controls.oldPassword.touched && passform.controls.newPassword.errors?.required && passform.controls.newPassword.touched && passform.controls.newPasswordconf.errors?.required && passform.controls.newPasswordconf.touched"-->
<!--        translate>labelErrorFill-->
<!--      </div>-->

<!--      <div-->
<!--        *ngIf="passform.errors?.doesMatchPassword && passform.controls.newPassword.touched && passform.controls.newPasswordconf.touched"-->
<!--        translate>labelErrorDoNotMatch-->
<!--      </div>-->

<!--      <div *ngIf="isOpen" translate>{{passChangeMessage}}</div>-->

<!--    </alert>-->

    <div class="form-group text-center">
      <button type="button" class="btn btn-info mt-5"
              [disabled]="!passform.valid" (click)="submitPassChange(); isOpen=true" [formGroup]="passform"
              translate>labelHeader.changePassword</button>
    </div>
  </form>

</ng-template>
